import React, { useEffect } from "react";
import { connect } from "react-redux";
import resolveModel from "react-redux-form/lib/utils/resolve-model";
import { compose } from "recompose";
import { Control, actions } from "react-redux-form";
import  {Input} from 'reactstrap';


export const AutoTextArea = ({ dispatch, id, ...props }) => {
  const adjustHeight = (element) => {
    if (element) {
      element.style.height = "auto";
      element.style.height = element.scrollHeight + "px";
    }
  };

  useEffect(() => {
    const textarea = document.querySelector(`#${id}`);
    if (textarea) {
      adjustHeight(textarea);
    }
  }, []); 

  const handleChange = (e) => {
    adjustHeight(e.target);
  };

  return (
    <Control.text
      component={Input}
      style={{ overflow: 'hidden' }}
      type="textarea"
      rows={1}
      onChange={handleChange}
      changeAction={(m, v) => {
        dispatch(actions.change(m, `${v}` ? v : undefined));
      }}
      id={id}
      {...props}
    />
  );
};

export const enhance = compose(
  resolveModel,
  connect(null, (dispatch, ownProps) => ({
    dispatch: ownProps.dispatch || dispatch,
  }))
);

export default enhance(AutoTextArea);
